import { render, staticRenderFns } from "./ListProfiles.vue?vue&type=template&id=227097f8&scoped=true&"
import script from "./ListProfiles.vue?vue&type=script&lang=ts&"
export * from "./ListProfiles.vue?vue&type=script&lang=ts&"
import style0 from "./ListProfiles.vue?vue&type=style&index=0&id=227097f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227097f8",
  null
  
)

export default component.exports